import { FC } from 'react';
import { triggerSuspense } from '../helpers/triggerSuspense';
import { useCheckoutSelector } from '../reducers/root';

export const CheckoutDeliveryStepSuspense: FC = () => {
    /**
     * When you add a new address, we show the delivery step without having finished resolving
     * delivery options. This should prevent it, forcing a loading state to be shown until we're
     * ready.
     */
    const deliveryOptionsComputing = useCheckoutSelector(
        state => state.ui.deliveryOptionsComputing
    );

    /**
     * We initially had this logic in `CheckoutDeliveryStep`, but in some cases (see ECOM-3377) that
     * component wouldn't get updated when `deliveryOptionsComputing` changes.
     *
     * We're not sure why, maybe there's some edge cases with suspense and class components, since
     * moving this logic to a function seems to have solved this issue.
     */
    if (deliveryOptionsComputing) {
        triggerSuspense();
    }
    return null;
};
